import { render, staticRenderFns } from "./LoadMoreTrigger.vue?vue&type=template&id=28e02ae7"
import script from "./LoadMoreTrigger.vue?vue&type=script&lang=js"
export * from "./LoadMoreTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports